import React from 'react';
import PropTypes from 'prop-types';
import {Nav, Navbar} from "react-bootstrap";
import {Link} from "react-router-dom";
import APP_VERSION from "../../version";
import { getCurrentSchoolYearStartYear } from "../common/schoolYear";
import { buildManageRouteWithSchoolYear } from "./manageSchoolYearRouting";
import SchoolYearSelector from "./SchoolYearSelector";

function ManageNav({
  items,
  signOut,
  currentSearch,
  activeSchoolYearStartYear,
  schoolYearOptions,
  onActiveSchoolYearChange,
  settingsRoute,
}) {
  return (
    <Navbar collapseOnSelect expand="lg" id="nav" className="manage-custom-nav fixed-top px-4 py-1 shadow-sm">
      <Navbar.Brand as={Link} to="/" className="p-1">
        <img
          src="../../resources/app/manage-logo.png"
          width="52px"
          height="52px"
          className="manage-custom-nav-logo"
          alt=""
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          {items.map(item => (
            <Nav.Link
              as={Link}
              eventKey={item.name}
              key={item.name}
              to={buildManageRouteWithSchoolYear(item.route, currentSearch, activeSchoolYearStartYear)}
              className="manage-custom-nav-link ml-1 my-0"
            >
              {item.name}
            </Nav.Link>
          ))}
        </Nav>
        <Nav className="align-items-lg-center ml-lg-2">
          <Navbar.Text className="manage-version-label ml-1 mr-lg-3 my-0">
            {APP_VERSION}
          </Navbar.Text>
          <div className="mr-lg-3 my-2 my-lg-0">
            <SchoolYearSelector
              activeSchoolYearStartYear={activeSchoolYearStartYear}
              options={schoolYearOptions}
              onChange={onActiveSchoolYearChange}
            />
          </div>
          {settingsRoute && (
            <Nav.Link
              as={Link}
              to={buildManageRouteWithSchoolYear(settingsRoute, currentSearch, activeSchoolYearStartYear)}
              title="Ustawienia"
              aria-label="Ustawienia"
              className="manage-custom-nav-link ml-1 my-0"
            >
              <i className="fas fa-cog fa-lg" />
            </Nav.Link>
          )}
          <Nav.Link onClick={signOut} className="manage-custom-nav-link ml-1 my-0">
            <i className="fas fa-sign-in-alt fa-lg" />
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

ManageNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    selected: PropTypes.bool,
    route: PropTypes.string,
    onClick: PropTypes.func,
  })).isRequired,
  signOut: PropTypes.func.isRequired,
  currentSearch: PropTypes.string,
  activeSchoolYearStartYear: PropTypes.number,
  schoolYearOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })),
  onActiveSchoolYearChange: PropTypes.func,
  settingsRoute: PropTypes.string,
};

ManageNav.defaultProps = {
  currentSearch: "",
  activeSchoolYearStartYear: getCurrentSchoolYearStartYear(),
  schoolYearOptions: [],
  onActiveSchoolYearChange: () => {},
  settingsRoute: null,
};

export default ManageNav;
